<template lang="html">

    <div class="contenedor-formulario">
        <form @submit.prevent="validate">
            <div class="contenedor-input">
                <input type="text" class="input-text"
                    v-validate="'required'"
                    v-model="data.email"
                    name="email" :placeholder="$t('formulario.email')+'*'" />
                <span :class="['error',{'animated shake' : view.clicked}]" v-if="view.clicked">{{ errors.first('email') }}</span>
            </div>

            <div class="contenedor-input">
                <input type="password" class="input-text"
                    v-validate="'required'"
                    v-model="data.password"
                    name="password" :placeholder="$t('formulario.password')+'*'" />
                <span :class="['error',{'animated shake' : view.clicked}]" v-if="view.clicked">{{ errors.first('password') }}</span>
            </div>

            <div class="contenedor-boton column-center">
                <button  class="btn red with-border" :loading="loading">Iniciar sesión</button>
            </div>


        </form>
    </div>

</template>

<script lang="js">

import VeeValidate from 'vee-validate';
import {mapActions} from 'vuex';

export default {
  name: 'formulario-login',
  data(){
      return{
          data : {
              email : '',
              password : ''
          },
          view : {
            clicked : false
          },
          loading : false
      }
  },
  methods : {
      ...mapActions(['login']),
      validate(){
        this.view.clicked = true;
        this.$validator.validateAll().then(canSend => {
          if(canSend){
              this.loading = true;
            this.login(this.data).then(r => {
                if(r){
                    this.loading = false;
                    this.$router.push({name : 'areainterna'})
                }
            })
          }
        });
      }
  }
}
  
</script>


<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/view-parts/login/formulario.vue